var map = {
	"./Black-Bishop.svg": 31458,
	"./Black-King.svg": 98652,
	"./Black-Knight.svg": 72510,
	"./Black-Pawn.svg": 95823,
	"./Black-Queen.svg": 55305,
	"./Black-Rook.svg": 14310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52166;